<div class="inner-wrapper fit-container">
    <div class="success-msg-wrap">
        <div class="success-img">
            <img src="assets/images/tick-bg.svg" alt="">
        </div>
        <h3>Congratulations!</h3>
        <p>Your application has been submitted successfully. <br> Our Enrollment Specialist will get in touch with you shortly.</p>
    </div>
</div>